module.exports = __webpack_public_path__ + "WorkSans-Bold.555a35719eb1cbc94420.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/sans/WorkSans-Bold.woff
// module id = ./src/assets/webfonts/sans/WorkSans-Bold.woff
// module chunks = styles